import * as React from "react";
import * as ComparePriceStyles from "../styles/ComparePrice";
import { formatPrice } from "../../../../../common-deprecated/Globalize";
import IconTag from "../../../../../common-deprecated/svg/lexus/tag.svg";
import type { EquipmentSpecNameIdValueType } from "../../../../../common-deprecated/features/compare/utils/newCarCompareTypes";
import IconWrapper from "../../../../../common-deprecated/styles/lexus/IconWrapper";
import { hasDualCurrency } from "../../../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import { useCompareV2Selector } from "../../../redux/store";

type ComparePriceAtomPropsType = {
    price?: EquipmentSpecNameIdValueType["price"];
    cultureName: string;
    showPrices: boolean;
};

const EquipmentOrSpecPrice = (props: ComparePriceAtomPropsType): JSX.Element | null => {
    const { cultureName, price, showPrices } = props;
    const hasSecondaryPrice = useCompareV2Selector((state) => hasDualCurrency(state.commonSettings));

    if (!price || !showPrices) {
        return null;
    }

    if (price.list === price.listWithDiscount) {
        return (
            <ComparePriceStyles.PricesWrapper>
                <ComparePriceStyles.Price>{formatPrice(price.list, cultureName)}</ComparePriceStyles.Price>
                {/* Dual currency price */}
                {hasSecondaryPrice && (
                    <ComparePriceStyles.Price>
                        {formatPrice(price.list, cultureName, false, true)}
                    </ComparePriceStyles.Price>
                )}
            </ComparePriceStyles.PricesWrapper>
        );
    } else {
        return (
            <>
                <IconWrapper iconColor="primary">
                    <IconTag />
                </IconWrapper>
                <ComparePriceStyles.PricesWrapper>
                    <ComparePriceStyles.LineThrough>
                        {formatPrice(price.list, cultureName)}
                    </ComparePriceStyles.LineThrough>
                    <ComparePriceStyles.Discount>
                        {formatPrice(price.listWithDiscount, cultureName)}
                    </ComparePriceStyles.Discount>
                </ComparePriceStyles.PricesWrapper>
            </>
        );
    }
};

export default EquipmentOrSpecPrice;
